'use strict';

var Util = {

    //Used to generate a unique ID when disabling
    _overlayIdSuffix: 'disabledOverlay',
    _resizeListenerAlreadyCreated: false,
    _resizingFunctions: new Array(),
    _DEFAULT_MIN_WIDTH: 50,
    _DEFAULT_MIN_HEIGHT: 50,

    /**
     * Sets alternating CSS on table rows. Can also be called to reset the
     * CSS after dynamically adding/removing rows.
     *
     * If the table has a tbody element, all rows in the tbody will be affected.
     * If there isn't a tbody, all rows in the table will be affected.
     * "numRowsToSkip" can be specified in the options, indicating to skip the
     * first N rows in the tbody if it exists, else the table.
     *
     * Also the CSS class names can be provided as
     * "oddCss" and "evenCss" properties in the options object.
     *
     * @param table can be the ID or also the actual table element.
     * @param options an optional parameter that can be used to override defaults
     */
    /* eslint-disable complexity */
    // used only in loadColumnSetModal
    setOddEvenRowCss: function(table, options) {
        //default that can be overridden
        var oddCss = 'oddRow';
        var evenCss = 'evenRow';
        var numRowsToSkip = 0;

        if (options) {
            if (options.oddCss) {
                oddCss = options.oddCss;
            }

            if (options.evenCss) {
                evenCss = options.evenCss;
            }

            if (options.numRowsToSkip) {
                numRowsToSkip = options.numRowsToSkip;
            }
        }

        if(typeof table === 'string'){
            table = document.getElementById(table);
        }
        //skip the header rows, if any, by getting rows from the tbody
        var rowContainer = table.getElementsByTagName('tbody')[0];

        if (rowContainer == null) {
            rowContainer = table;
        }

        var rows = rowContainer.getElementsByTagName('tr');
        if (rows == null) {
            //I don't think this should ever happen.  The list
            //should be empty instead of null, but just in case...
            return;
        }

        //we ignore rows that aren't visible
        var visibleRowsCounter = 0;
        for (var i = numRowsToSkip; i < rows.length; i++) {
            var $row = jQuery(rows[i]);
            if ($row.is(':visible')) {
                if (visibleRowsCounter % 2 === 0) {
                    $row.removeClass(evenCss);
                    $row.addClass(oddCss);
                } else {
                    $row.removeClass(oddCss);
                    $row.addClass(evenCss);
                }
                visibleRowsCounter++;
            }
        }
    },
    /* eslint-enable complexity */

    /**
     * Applies a highlighting effect using a CSS class.
     *
     * @param elementId The ID of the element to be highlighted.
     */
    applyHighlightEffect: function (elementId) {
        var $element = jQuery('#' + elementId);
        $element.addClass('flash-highlight');
    },

    /**
     * Takes an element and covers it in a semi-transparent div to
     * make the element un-usable and look disabled.  Note that unlike
     * using the disabled property on form elements, this does not affect
     * what is posted to the server.  The advantage is that any element can be
     * disabled, including an entire div or page.  This function
     * needs the disabled element to have an ID, so if it doesn't have one,
     * the element will be assigned a randomly generated ID that
     * is guaranteed to be unique.
     *
     * Note: The semi-transparent div is drawn on top of an element when
     * this is called.  If the page is dynamically changed and the element's
     * position changes, the element should be re-disabled so that the
     * div will be re-drawn in the element's new position.
     *
     * Note: This function modifies the DOM, so it must be called after the
     * page has fully loaded.
     *
     * @param element can be an ID or an actual element to disable
     * @param options an optional parameter that can be used to override defaults
     */
    /* eslint-disable complexity */
    disable: function(element, options) {
        //default that can be overridden
        var disabledColor = 'white';
        var opacity = '0.8';
        var zIndex = null;
        var cursor = null;

        if (options) {
            if (options.disabledColor) {
                disabledColor = options.disabledColor;
            }

            //opacity may be 0 which is different from our default
            if (typeof options.opacity != 'undefined') {
                opacity = options.opacity;
            }

            //zIndex may be 0 which is different from our default
            if (typeof options.zIndex != 'undefined') {
                zIndex = options.zIndex;
            }

            if (options.cursor) {
                cursor = options.cursor;
            }
        }

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        if (!element.id || element.id === '') {
            var randomId = 'randomId_' + new Date().getTime();

            while (document.getElementById(randomId)) {
                randomId = 'randomId_' + new Date().getTime();
            }

            element.id = randomId;
        }
        var overlayId = element.id + this._overlayIdSuffix;

        //get the overlay element, or create it if necissary
        var overlayElement = document.getElementById(overlayId);
        if (!overlayElement) {
            overlayElement = document.createElement('div');
            overlayElement.id = overlayId;
            overlayElement.style.backgroundColor = disabledColor;
            overlayElement.style.position = 'absolute';
            overlayElement.style.display = 'none';
            overlayElement.style.opacity = opacity;

            if (cursor) {
                overlayElement.style.cursor = cursor;
            }

            if (zIndex) {
                overlayElement.style.zIndex = zIndex;
            }

            //add the element to the parent instead of the body of the document so that:
            // 1) When the parent element moves the overlay moves with it
            // 2) When the parent element goes away the overlay is destroyed too
            var parentNode = element.parentNode;
            parentNode.appendChild(overlayElement);
        }

        //position the overlay each time in case the parent element has
        //changed position or size
        var parentDimensions;

        var $element = jQuery(element);

        if (element === document.body || element === document.documentElement) {
            //Its surprisingly difficult to get the dimensions of the entire page.
            //I didn't find anything in prototype to provide it, and this is the only
            //thing I've found that works.
            var body = document.body;
            var documentElement = document.documentElement;
            parentDimensions = {
                height: Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight),
                width: Math.max(body.scrollWidth, documentElement.scrollWidth, body.offsetWidth, documentElement.offsetWidth)
            };
        } else {
            parentDimensions = {
                width: $element.outerWidth(),
                height: $element.outerHeight()
            };
        }

        //make the position of the overlay the same relative position of 
        //the element, because the overlay is on the parent just like the element 
        var parentPosition = $element.position();

        overlayElement.style.height = parentDimensions.height + 'px';
        overlayElement.style.width = parentDimensions.width + 'px';
        overlayElement.style.left = parentPosition.left + 'px';
        overlayElement.style.top = parentPosition.top + 'px';

        // give it the same margin as the overlaid element so they match up
        overlayElement.style.marginLeft = $element.css('margin-left');
        overlayElement.style.marginTop = $element.css('margin-top');

        jQuery(overlayElement).show();
    },
    /* eslint-enable complexity */

    /**
     * Enables an element previously disabled with the disable function.
     */
    enable: function(element) {
        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var overlay = document.getElementById(element.id + this._overlayIdSuffix);
        if (overlay) {

            jQuery(overlay).remove();
            if (ie6) {
                //show the boxes we previously hid
                var selectBoxes = element.getElementsByTagName('select');
                for (var i = 0; i < selectBoxes.length; i++) {
                    jQuery(selectBoxes[i]).show();
                }
            }
        }
    },

    /**
     * Makes text in an element unselectable.  Useful for widget headings
     * and drag/drop items.
     */
    disableTextSelection: function (element) {
        if (typeof element === 'string') {
            element = document.getElementById(element);
        }
        //Note: note sure if this implementation is the best. Found this
        //code on the web.  Seems like there should be a better way
        if (typeof element.onselectstart != 'undefined') {
            //IE
            element.onselectstart = function () {
                return false;
            };
        } else if (typeof element.style.MozUserSelect != 'undefined') {
            //Firefox
            element.style.MozUserSelect = 'none';
        } else {
            //All others (Opera etc)
            element.onmousedown = function () {
                return false;
            };
        }
    },

    /** Sizes an element (usually a DIV) to fill up the width of the screen.
     * @param options an optional parameter that can be used to override defaults. Can
     *      contain any of the following:
     *      buffer: Instead of filling up the entire width of the screen, leave
     *          this many pixels between the element and the right edge.
     */

    autoSizeWidth: function(element, options) {
        this._initResizeListener();

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var buffer = 5;
        if (options.buffer) {
            buffer = options.buffer;
        }

        var minWidth = this._DEFAULT_MIN_WIDTH;
        if (options.minWidth) {
            minWidth = options.minWidth;
        }

        var scaling = 1;
        if (options.scaling) {
            scaling = options.scaling;
        }


        var resizeFunction = function(windowSize) {
            var leftOffset = jQuery(element).offset().left;
            var newWidth = windowSize.width - buffer - leftOffset;
            newWidth = newWidth * scaling;
            if (newWidth < minWidth) {
                newWidth = minWidth;
            }
            element.style.width = newWidth + 'px';
        }.bind(this);

        this._resizingFunctions.push(resizeFunction);

        resizeFunction(this.getViewportDimensions());
    },

    /** Sizes an element (usually a DIV) to fill up the height of the screen.
     * @param an optional parameter that can be used to override defaults. Can
     *      contain any of the following:
     *      buffer: Instead of filling up the entire height of the screen, leave
     *          this many pixels between the element and the bottom edge.
     */

    autoSizeHeight: function(element, options) {
        this._initResizeListener();        

        if (!options) {
            options = {};
        }

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var buffer = 15;
        if (options.buffer) {
            buffer = options.buffer;
        }

        var scaling = 1;
        if (options.scaling) {
            scaling = options.scaling;
        }

        var minHeight = this._DEFAULT_MIN_HEIGHT;
        if (options.minHeight) {
            minHeight = options.minHeight;
        }


        var resizeFunction = function(windowSize) {
            var topOffset = jQuery(element).offset().top;
            var newHeight = windowSize.height - buffer - topOffset;
            newHeight = newHeight * scaling;
            if (newHeight < minHeight) {
                newHeight = minHeight;
            }
            element.style.height = newHeight + 'px';
        }.bind(this);

        this._resizingFunctions.push(resizeFunction);

        resizeFunction(this.getViewportDimensions());
    },

    _initResizeListener: function() {
        if (this._resizeListenerAlreadyCreated) {
            return;
        }
        this._resizeListenerAlreadyCreated = true;

        jQuery(window).on('resize', function() {
            this.forceResizeWindow();
        }.bind(this));
    },
    
    forceResizeWindow: function(){
        //Only calculate the window size once because it can be slow
        var dimensions = this.getViewportDimensions();
        for (var i = 0; i < this._resizingFunctions.length; i++) {
            this._resizingFunctions[i](dimensions);
        }
    },

    getViewportDimensions: function() {
        var $window = jQuery(window);
        return {
            width: $window.width(),
            height: $window.height()
        };
    }

};

module.exports = Util;


//////////////////
// WEBPACK FOOTER
// ./mits/UI/Util.js
// module id = 5
// module chunks = 0